import useSearchParams from './useSearchParams';

export const MARKETING_PREFIX = 'utm_';

const useMarketingSearchParams = () => {
  const searchParams = useSearchParams();

  const marketingSearchParams = new URLSearchParams();

  searchParams.forEach((value, key) => {
    if (key.startsWith(MARKETING_PREFIX)) {
      marketingSearchParams.append(key, value);
    }
  });

  return marketingSearchParams;
};

export default useMarketingSearchParams;
